/**
 * The app's ONE filter mark — three sliders, the drawing the plan library was given.
 *
 * It lived twice: `pages/plan-library/ui/PlanLibraryIcons.tsx` drew it for the library's toolbar and
 * `features/exercise-library-rail` drew the same nine-segment path again for the drawer's own
 * filters. The paths were identical to the character, which is the shape a duplicate takes right
 * before the two drift. Promoted here on its second real consumer, which is this file's own rule.
 *
 * A feature may not import from a page, so this is also the only place the two could have met.
 */

interface FilterIconProps {
  readonly className?: string;
}

export function FilterIcon({ className }: FilterIconProps) {
  return (
    <svg
      className={className}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      aria-hidden
      focusable="false"
    >
      <path d="M4 21v-7M4 10V3M12 21v-9M12 8V3M20 21v-5M20 12V3M1 14h6M9 8h6M17 16h6" />
    </svg>
  );
}
